import { createContext, useContext } from 'react';

type Props = {
  children: React.ReactNode;
  value: boolean;
};

const IsInHomeContext = createContext<boolean>(false);

export function IsInHomeProvider({ value, children }: Props) {
  return (
    <IsInHomeContext.Provider value={value}>
      {children}
    </IsInHomeContext.Provider>
  );
}

export function useIsInHome() {
  return useContext(IsInHomeContext);
}
